import {
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from '@mui/material';

interface KeyboardShortcutsModalProps {
  open: boolean;
  onClose: () => void;
}

export function KeyboardShortcutsModal({ open, onClose }: KeyboardShortcutsModalProps) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Scorciatoie tastiera</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Su campi di testo, <strong>Ctrl+K</strong> apre comunque la ricerca globale. Altri tasti rapidi sono
          disattivati mentre scrivi.
        </Typography>
        <Table size="small">
          <TableBody>
            <TableRow>
              <TableCell>
                <Typography variant="body2" fontWeight={600}>
                  Ctrl / ⌘ + K
                </Typography>
              </TableCell>
              <TableCell>Ricerca globale</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography variant="body2" fontWeight={600}>
                  ?
                </Typography>
              </TableCell>
              <TableCell>Questa finestra</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography variant="body2" fontWeight={600}>
                  N
                </Typography>
              </TableCell>
              <TableCell>Nuova commessa (se permesso)</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography variant="body2" fontWeight={600}>
                  R
                </Typography>
              </TableCell>
              <TableCell>Vai all&apos;elenco commesse</TableCell>
            </TableRow>
          </TableBody>
        </Table>
        <Stack sx={{ mt: 2 }}>
          <Typography variant="caption" color="text.secondary">
            Suggerimento: usa la lente in alto per aprire la ricerca anche su mobile.
          </Typography>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
